/**
 * Monogram / hand-painted warehouse routing — matches old theme behavior.
 * Sets properties[_isMonogramItem] when Stylux fills monogram fields on submit.
 */
window.appendMonogramRoutingProperties = function appendMonogramRoutingProperties(formData) {
  if (!formData || typeof formData.append !== 'function') return formData;

  var existingFlag = formData.get('properties[_isMonogramItem]');
  if (existingFlag) return formData;

  var monogramText = formData.get('properties[Monogram Text]') || '';
  var monogramFont = formData.get('properties[Font]') || '';

  if (String(monogramText).trim() || String(monogramFont).trim()) {
    formData.append('properties[_isMonogramItem]', 'true');
  }

  return formData;
};

/** Quick view modal: sync monogram hidden field + button class when swatch/slide changes. */
window.updateQuickViewMonogramState = function updateQuickViewMonogramState(quickViewModal, isMonogram, forceMonogram) {
  if (!quickViewModal) return;

  var monogramInput = quickViewModal.querySelector('[data-quick-view-monogram-property]');
  var submitButton = quickViewModal.querySelector('[data-quick-view-atc]');
  var shouldFlag = !!(forceMonogram || isMonogram);

  if (monogramInput) {
    if (forceMonogram) {
      monogramInput.disabled = false;
      monogramInput.value = 'true';
    } else {
      monogramInput.disabled = true;
      monogramInput.value = '';
    }
  }

  if (submitButton) {
    submitButton.classList.toggle('is-monogram', shouldFlag);
  }
};

/** Quick view add-to-cart: append _isMonogramItem from hidden field or is-monogram button class. */
window.applyQuickViewMonogramProperties = function applyQuickViewMonogramProperties(formData, quickViewModal) {
  if (!formData || typeof formData.append !== 'function') return formData;
  if (formData.get('properties[_isMonogramItem]')) return formData;

  var monogramInput = quickViewModal && quickViewModal.querySelector('[data-quick-view-monogram-property]');
  if (monogramInput && !monogramInput.disabled && monogramInput.value) {
    formData.append('properties[_isMonogramItem]', 'true');
    return formData;
  }

  var submitButton = quickViewModal && quickViewModal.querySelector('[data-quick-view-atc]');
  if (submitButton && submitButton.classList.contains('is-monogram')) {
    formData.append('properties[_isMonogramItem]', 'true');
  }

  return formData;
};

/** Collection quick-add: read monogram routing flag from button (class + data attrs). */
window.getCollectionQuickAddMonogramProperties = function getCollectionQuickAddMonogramProperties(button) {
  var properties = {};
  if (!button) return properties;

  var shouldFlag =
    button.classList.contains('is-monogram') ||
    button.dataset.isMonogram === 'true' ||
    button.dataset.forceMonogram === 'true';

  if (shouldFlag) {
    properties._isMonogramItem = 'true';
  }

  return properties;
};

/** Keep quick-add button monogram state in sync when collection swatches change product. */
window.syncCollectionQuickAddMonogramState = function syncCollectionQuickAddMonogramState(quickAddBtn, productDataEl) {
  if (!quickAddBtn) return;

  var isMonogram = false;
  var forceMonogram = false;

  if (productDataEl) {
    isMonogram = productDataEl.dataset.isMonogram === 'true';
    forceMonogram = productDataEl.dataset.forceMonogram === 'true';
  } else {
    isMonogram = quickAddBtn.dataset.isMonogram === 'true';
    forceMonogram = quickAddBtn.dataset.forceMonogram === 'true';
  }

  var shouldFlag = isMonogram || forceMonogram;
  quickAddBtn.classList.toggle('is-monogram', shouldFlag);
  quickAddBtn.dataset.isMonogram = shouldFlag ? 'true' : 'false';
  quickAddBtn.dataset.forceMonogram = forceMonogram ? 'true' : 'false';
};
